export const PLAN_REACTIVATION_STEPS = [
  {
    title: 'Load enrollment',
    description: 'Previous enrollment will not be automatically reactivated even if the plan was reactivated. Employees must be re-enrolled into each account.',
  },
  {
    title: 'Review payroll calendars',
    description: 'If your plans support scheduled contributions, review any supported payroll calendars.',
  },
];
